export enum NotifType {
  Failures = "Failures",
  Updates = "Updates",
  Information = "Information",
  Warnings = "Warnings"
}

export const NotifTypeValues = Object.values(NotifType).filter(value => typeof value === 'string') as string[];

export type NotifResponseItem = {
  "id": string,
  "status": number, // not used for now
  "title": string, 
  "message": string,
  "messageType": StatusEnum,
  "expirationAt": string,
  "startAt": string, 
  "createdAt": string,
  "createdBy": string,
  "modifiedAt": string,
  "modifiedBy": string,
}

export type NotifWSResponseItem = {
  "Id": string,
  "Status": number, // not used for now
  "Title": string, 
  "Message": string,
  "MessageType": StatusEnum,
  "ExpirationAt": string,
  "StartAt": string, 
  "CreatedAt": string,
  "CreatedBy": string,
  "ModifiedAt": string,
  "ModifiedBy": string,
}

export enum StatusEnum {
  Ok = "Ok",
  NotFound = "NotFound",
  Error = "Error",
  NotChecked = "NotChecked",
  Info = "Info",
  Success = "Success",
  Warn = "Warn",
  Failures = "Failures",
  Updates = "Updates",
  Information = "Information",
  Warnings = "Warnings"
}


export const statusToDisplayType = {
  [StatusEnum.Ok]: "success",
  [StatusEnum.NotFound]: "error",
  [StatusEnum.Error]: "error",
  [StatusEnum.NotChecked]: "error",
  [StatusEnum.Info]: "information",
  [StatusEnum.Success]: "success",
  [StatusEnum.Warn]: "warning",
  [StatusEnum.Information]: "information",
  [StatusEnum.Updates]: "success",
  [StatusEnum.Failures]: "error",
  [StatusEnum.Warnings]: "warning",

} as const;

const status = StatusEnum.Ok;
export const displayType = statusToDisplayType[status];

export function getDisplayType(message: string): string {
  // Convert string to StatusEnum value
  const status = StatusEnum[message as keyof typeof StatusEnum];
  return statusToDisplayType[status as StatusEnum];
}